// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root.search-form {\n  padding: 20px 15px 10px;\n}\n", ""]);
// Exports
module.exports = exports;
